import React from 'react';
import { AddressSelectionProvider } from './AddressSelectionProvider';
import { useAddressMutationFunctions } from './useAddressMutationFunctions';
import { AddressSelection } from './AddressSelection';
import { Modal, ModalContents, StyledModalDismissButton } from '../modal';
import styled from 'styled-components';
import { colors } from '../../theme/color';
import { ModalName } from '../modal/modalNames';

export const ADDRESS_SELECTION_MODAL_NAME = ModalName.ALOITA_TILAUS;

export type Props = {
  isHomepage?: boolean;
  onRestaurantSelected?: () => void;
  children?: React.ReactNode;
  preselectedRestaurantId?: number;
};

export const AddressSelectionRoot: React.FC<Props> = (props) => {
  const { ...addressHandlers } = useAddressMutationFunctions();

  return (
    <AddressSelectionProvider {...addressHandlers} {...props}>
      <AddressSelection />
    </AddressSelectionProvider>
  );
};

// Used on other pages than shopping cart. Provides the context for its children, and adds the modal.
export const AddressSelectionModalProvider: React.FC<Props> = ({
  children,
  preselectedRestaurantId,
  ...props
}) => {
  const { ...addressHandlers } = useAddressMutationFunctions();

  return (
    <AddressSelectionProvider {...props} {...addressHandlers}>
      {children}
      <Modal name={ADDRESS_SELECTION_MODAL_NAME}>
        <StyledModalContents
          maxWidth="lg"
          fullWidth={true}
          title="Muokkaa toimitustapaa"
          aria-labelledby="address-selection-modal"
          noWrapper
        >
          <AddressSelection preselectedRestaurantId={preselectedRestaurantId} />
        </StyledModalContents>
      </Modal>
    </AddressSelectionProvider>
  );
};

const StyledModalContents = styled(ModalContents)`
  ${StyledModalDismissButton} {
    color: ${colors.textDefault};
  }
`;
